'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleReturn = require('./handleReturn');

var _handleReturn2 = _interopRequireDefault(_handleReturn);

var _onEscape = require('./onEscape');

var _onEscape2 = _interopRequireDefault(_onEscape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Requires the following props:
 *  - stopEditing
 */
// Handlers
exports.default = function () {
  return {
    handleReturn: _handleReturn2.default,
    // Stop editing on escape
    onEscape: _onEscape2.default
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/milanoteShortcuts/index.js
// module id = 687
// module chunks = 0